module.exports = require("he");


//////////////////
// WEBPACK FOOTER
// external "he"
// module id = 26
// module chunks = 0